export const OFFER_ONE = 'one';
export const OFFER_EVO = 'evo';

export const OFFER_TYPE_CLIENT = 'lepack-client';
export const OFFER_TYPE_PROSPECT = 'lepack-client';
export const OFFER_TYPE_CREATION_AGENCE = 'lepack-creation-agence';
